// extracted by mini-css-extract-plugin
module.exports = {"description":"_2m5Tk_6Ho37jwNY5wQ-hm4","no_description":"_3WHvbLfCxqRPiQ9mh6lB_9"};